/**
 * Runs `fn` for each item strictly one after another, in array order, and resolves with the results in the same order.
 * An item only starts once the previous item's promise has resolved; the first rejection stops the chain
 * (later items are never started) and is propagated. Built as a promise chain, so there is no await inside a loop.
 */
export const runSequentially = <T, R>(items: readonly T[], fn: (item: T, index: number) => Promise<R>): Promise<R[]> =>
  items.reduce<Promise<R[]>>(
    (previous, item, index) =>
      previous.then(async (results) => {
        results.push(await fn(item, index));
        return results;
      }),
    Promise.resolve([])
  );
